export default __webpack_public_path__ + "static/media/Market-Analysis.757ee9de.png";